export default __webpack_public_path__ + "cb98e464ae5c59570c70befbcc169dc1.png";